class Enviroment {
  public get (): 'development' | 'staging' | 'production' {
    if (window.location.host === 'dev.community-playlist.com' || process.env.VUE_APP_STAGING) {
      return 'staging'
    }

    if (window.location.hostname === 'localhost') {
      return 'development'
    }

    return 'production'
  }
}

export default new Enviroment().get()
